export const AD_SEGMENTS = [
  { value: "REAL_ESTATE", label: "Imóveis" },
  { value: "ANIMALS", label: "Animais" },
  { value: "AGRO_SERVICES", label: "Serviços Agro" },
  { value: "AGRO_PLUS", label: "Agro+" },
] as const;

export type AdSegment = (typeof AD_SEGMENTS)[number]["value"];

export function getAdSegmentLabel(segment: AdSegment | null): string {
  return AD_SEGMENTS.find((option) => option.value === segment)?.label ?? "Não classificado";
}
